<template>
  <div class="substep-download-app">
    <div class="substep-header">
      <h3 data-testId="step-title">Download the app</h3>
      <p v-if="gated">
        This is used to track time to your projects and tasks
      </p>
      <p v-else>
        You're almost there! Finish onboarding by downloading the desktop app to track time to your projects.
      </p>
    </div>
    <div class="substep-body">
      <AppAlert
        v-if="gated"
        type="info"
        icon-classes="hi hi-info"
        message="Your organization requires you to track time with the desktop app"
      />
      <div id="download-app-images">
        <img
          v-for="(image, index) in images"
          :key="index"
          :src="image"
          alt="Download App"
        />
      </div>
      <a
        class="btn btn-primary"
        :href="downloadUrl"
        target="_blank"
        rel="noopener noreferrer"
        @click="handleDownloadClick"
      >
        Download the app
      </a>
    </div>
  </div>
</template>

<script>
import GettingStartedMixin from '~/mixins/GettingStarted/GettingStartedMixin';
import { GETTING_STARTED } from '~/app_constants';

export default {
  name: 'DownloadTheDesktopApp',
  mixins: [GettingStartedMixin],
  props: {
    downloadUrl: {
      type: String,
      required: true,
    },
    gated: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    images: GETTING_STARTED.app_images,
  }),
  mounted() {
    if (!this.gated) {
      this.$emit('completeSubstep');
    }
  },
  methods: {
    handleDownloadClick() {
      window.analytics?.track('Desktop app download clicked', {
        experiment: this.gated,
      });

      if (this.gated) {
        this.$emit('completeSubstep');
      }
    },
  },
};
</script>
